export default __webpack_public_path__ + "static/GoW_Logo-eb8ea7d1f46042643a1e9c717a6b46f2.png";